<!-- Skeleton shown while async data is loading -->
@if (isFormLoading) {
<c-card>
  <c-card-body>

    <!-- Header: entity type name + create/edit subtitle -->
    <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { id: 'header-title',    width: '45%', height: '1.4rem', marginBottom: '0.35rem' },
          { id: 'header-subtitle', width: '60%', height: '0.9rem', marginBottom: '1.5rem' }
        ] } }">
    </optima-progress-indicator>

    <!-- Base entity fields: name · description · owner+parent (row) · icon -->
    <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { id: 'field-name',        width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-description', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-owner',       width: '48%',  height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-parent',      width: '48%',  height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'field-icon',        width: '60%',  height: '2.5rem', marginBottom: '1.75rem' }
        ] } }">
    </optima-progress-indicator>

    <!-- Deliverable-specific fields (date range, target value etc.) -->
    <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { id: 'deliverable-field-1', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
          { id: 'deliverable-field-2', width: '100%', height: '2.5rem', marginBottom: '1.75rem' }
        ] } }">
    </optima-progress-indicator>

    <!-- KPI box section -->
    <div class="mb-3">
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'kpi-box-heading', width: '20%', height: '1rem', marginBottom: '0.75rem' }
          ] } }">
      </optima-progress-indicator>
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'kpi-box-row-1', width: '100%', height: '3rem', marginBottom: '0.75rem' },
            { id: 'kpi-box-row-2', width: '100%', height: '3rem', marginBottom: '1.5rem' }
          ] } }">
      </optima-progress-indicator>
    </div>

    <!-- Plan section -->
    <div class="mb-3">
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'plan-heading', width: '22%', height: '1rem', marginBottom: '0.75rem' }
          ] } }">
      </optima-progress-indicator>
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'plan-content', width: '100%', height: '6rem', marginBottom: '1.5rem' }
          ] } }">
      </optima-progress-indicator>
    </div>

    <!-- Section: Additional Info -->
    <div class="mb-1">
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'additional-info-heading', width: '30%', height: '1rem', marginBottom: '1rem' }
          ] } }">
      </optima-progress-indicator>
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'additional-info-field-1', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
            { id: 'additional-info-field-2', width: '80%',  height: '2.5rem', marginBottom: '1.75rem' }
          ] } }">
      </optima-progress-indicator>
    </div>

    <!-- Section: Relationships -->
    <div class="mb-3">
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'relationships-heading', width: '28%', height: '1rem', marginBottom: '0.75rem' }
          ] } }">
      </optima-progress-indicator>
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'relationships-label',   width: '40%',  height: '0.9rem', marginBottom: '0.75rem' },
            { id: 'relationships-field-1', width: '100%', height: '2.5rem', marginBottom: '0.75rem' },
            { id: 'relationships-field-2', width: '75%',  height: '2.5rem', marginBottom: '1.75rem' }
          ] } }">
      </optima-progress-indicator>
    </div>

    <!-- Submit button row -->
    <div class="d-flex justify-content-end mt-2">
      <optima-progress-indicator [progress]="formLoadingProgress" [view]="ProcessProgressView.Shimmer" [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
            { id: 'submit-button', width: '10rem', height: '2.4rem', borderRadius: '0.375rem' }
          ] } }">
      </optima-progress-indicator>
    </div>

  </c-card-body>
</c-card>
}

<!-- Real form — always in DOM so child ngOnInit async work runs in parallel -->
<c-card [hidden]="isFormLoading" class="form-biz-entity-card">
  <c-card-header>
    <div class="h2 mb-0">{{ formHeaderTitle }}</div>
    <small>{{ formHeaderSubtitle }}</small>
  </c-card-header>
  <c-card-body class="form-biz-entity-scroll-body">

    <app-form-base-entity #baseEntityForm [bizEntity]="deliverableBizEntity" [isEditing]="isEditing"
      [excludeParentAndOwner]="false"
      [enableParentForCategory]="enableParentForCategory"
      (formReady)="onFormReady()"
      (parentEntitySet)="onParentEntitySet($event)">
    </app-form-base-entity>
    @if (objectiveSummaryText) {
    <p class="text-medium-emphasis mb-0 mx-3">{{ objectiveSummaryText }}</p>
    }
    <optima-form-layout [layout]="formLayout"></optima-form-layout>

    <c-card class="mb-3 kpi-box">
      <c-card-header class="d-flex justify-content-between align-items-center">
        <h6>KPI's</h6>
        @if (!isEditing) {
        <c-form-check class="m-1" sizing="lg" [switch]="true" inline="true">
          <input cFormCheckInput type="checkbox" (change)="setAutoKPIState($event)" checked />
          <label cFormCheckLabel>Auto Generate</label>
        </c-form-check>
        }
      </c-card-header>
      <c-card-body>
        @for (ctrl of kpiTriggerControls; track ctrl.type + ctrl.label) {
        <app-polymorphic-control [c]="ctrl" (valueChange)="onKpiTriggerValueChange($event)">
        </app-polymorphic-control>
        }
      </c-card-body>
    </c-card>

    <app-plan-form #planForm [startValue]="getStartValue()" [endValue]="getTargetValue()"
      [startDate]="dateRangePolyControlMeta.dateRangeValueFromString"
      [endDate]="dateRangePolyControlMeta.dateRangeValueToString" [plan]="plan" [isEditing]="isEditing"
      [unit]="deliverableBizEntity.unit" (planGenerated)="generatedPlan($event)"></app-plan-form>

    @if(deliverableBizEntity && deliverableBizEntity.type.additionalFields &&
    deliverableBizEntity.type.additionalFields.length > 0) {
    <app-additional-info #additionalInfoForm [bizEntity]="deliverableBizEntity">
    </app-additional-info>
    }


    @if (relationshipConfigurations && relationshipConfigurations.length > 0) {
    <div class="relationship-section mb-4">
      <h6 class="mb-3">Relationships</h6>
      @for (config of relationshipConfigurations; track config; let i = $index) {
      <app-form-relationship-fields #relationshipFields [config]="config" [isEditing]="isEditing"
        [parentBizEntity]="deliverableBizEntity" [linkedBizEntities]="getTargetBizEntity(config)"
        [BizEntities]="bizEntities" (bizEntityAdditionalInfo)="onBizEntityAdditionalInfo($event, i)"
        (bizEntityAdditionalInfoForEdit)="onBizEntityAdditionalInfoForEdit($event)">
      </app-form-relationship-fields>
      }
    </div>
    }

  </c-card-body>
  <div class="form-biz-entity-footer">
    <optima-form-layout [layout]="formFooterLayout" (formDataChange)="onDeliverableSave()"></optima-form-layout>
  </div>
</c-card>